import { render, staticRenderFns } from "./bindingInformation.vue?vue&type=template&id=5ff7848e&scoped=true&"
import script from "./bindingInformation.vue?vue&type=script&lang=js&"
export * from "./bindingInformation.vue?vue&type=script&lang=js&"
import style0 from "./bindingInformation.vue?vue&type=style&index=0&id=5ff7848e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff7848e",
  null
  
)

export default component.exports